import React, { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useT } from '../i18n';

export default function OfflineBanner() {
  const { t } = useT();
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const goOffline = () => setOnline(false);
    const goOnline = () => {
      setOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!online) {
    return (
      <div className="xp-offline-banner" role="alert">
        <WifiOff className="w-4 h-4" />
        {t('No internet connection')}
      </div>
    );
  }

  if (showReconnected) {
    return (
      <div className="xp-offline-banner xp-offline-banner--online" role="status">
        <Wifi className="w-4 h-4" />
        {t('Connection restored')}
      </div>
    );
  }

  return null;
}
